export const ApiEditorSizes = {
  MINIMUM: 34,
  POPUP_SIZE: 400,
  POPUP_THRESHOLD: 100,
};
